
import React from "react";
import { AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
import arrowBackIcon from '../../../../../assests/icons/arrowRigth.svg'
import Tooltip from "../../tooltip/Tooltip";
import classes from './StteperHeader.module.css'

const StepperHeader = ({ currentStep, validChildren, texts, onPrev }) => {
    const currentChild = validChildren[currentStep];

    return (
        <div className={classes.Header}>
            {currentChild?.props?.prev &&
                <Tooltip showTooltip={false} text={texts.prev}>
                    <AccessibilityClickableDiv accessibilityDescription={texts.prev || "Prev"} onClick={onPrev}>
                        <AccessibilityHiddenImg className={classes.Prev} src={arrowBackIcon} />
                    </AccessibilityClickableDiv>
                </Tooltip>
            }

            {currentChild?.props?.title && <p className={classes.Title}>{currentChild.props.title}</p>}
        </div>
    );
};
export default StepperHeader